import { sendTracking } from '../../js/tracking';

class ProductOverviewSlider {
    constructor (element, options) {
        const defaults = {
            resizeTimeout: 150,
            trackingAttr: 'data-trackingcategory'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$teaserItems = element;
        this.trackingCategory = this.$teaserItems.getAttribute(this.settings.trackingAttr);
        this.currentIndex = 0;
    }

    initialize () {
        const breakpoint = window.matchMedia('(min-width:1024px)');
        let teaserSlider = null;
        let resizeTimer = null;

        const handleSlider = (Slider) => {
            let clicked = false;
            if (breakpoint.matches === false) {
                if (teaserSlider == null) {
                    teaserSlider = new Slider(this.$teaserItems, {
                        breakpoints: null,
                        speed: 500,
                        indicators: true,
                        prevnext: true,
                        paginationClickable: false,
                        prevAriaLabel: this.$teaserItems.dataset.slidePrevAriaLabel,
                        nextAriaLabel: this.$teaserItems.dataset.slideNextAriaLabel,
                        slidesPerView: 'auto',
                        initAttr: 'data-productoverview',
                        onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                            if (this.trackingCategory !== null) {
                                let direction;
                                if (currentIndex > this.currentIndex) {
                                    direction = 'forth';
                                } else {
                                    direction = 'back';
                                }

                                if (clicked === false) {
                                    sendTracking({
                                        category: this.trackingCategory,
                                        action: 'swipe',
                                        label: 'slide_' + direction + '_' + (currentIndex + 1)
                                    });
                                }

                                this.currentIndex = currentIndex;
                                clicked = false;
                            }
                        },
                        onClickPrev: (currentIndex) => {
                            clicked = true;

                            if (this.trackingCategory !== null) {
                                sendTracking({
                                    category: this.trackingCategory,
                                    action: 'click',
                                    label: 'btn_back_' + (currentIndex + 1)
                                });
                            }
                        },
                        onClickNext: (currentIndex) => {
                            clicked = true;

                            if (this.trackingCategory !== null) {
                                sendTracking({
                                    category: this.trackingCategory,
                                    action: 'click',
                                    label: 'btn_forth_' + (currentIndex + 1)
                                });
                            }
                        }
                    });
                }
            } else {
                if (teaserSlider !== null) {
                    teaserSlider.sliderDestroy();
                    teaserSlider = null;
                }
            }
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            const handleResize = () => {
                clearTimeout(resizeTimer);
                resizeTimer = window.setTimeout(() => {
                    handleSlider(Slider);
                }, this.settings.resizeTimeout);
            };

            window.addEventListener('resize', handleResize, false);
            window.addEventListener('orientationchange', handleResize, false);

            handleSlider(Slider);
        });
    }
}

export { ProductOverviewSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productOverviewSliders = $context.querySelectorAll('[data-productoverview="slider"]');

        if ($productOverviewSliders.length > 0) {
            for (let i = 0; i < $productOverviewSliders.length; i++) {
                const $productOverviewSlider = new ProductOverviewSlider($productOverviewSliders[i]);
                $productOverviewSlider.initialize();
            }
        }
    }
});
